import React, { FC } from 'react';
import { Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import PruRoute from '../../../../../common/components/PruRoute';
import { NOT_FOUND_ERROR_PAGE_PATH } from '../../../../../common/constants';
import {
  RECRUIT_LIBRARY_BASE_PATH,
  HAPPY_SHARE_MATERIAL_BASE_PATH,
  HAPPY_SHARE_LIBRARY_BASE_PATH,
} from '../../../constants';
import HappyShareLibraryListPage from './HappyShareLibraryListPage';
import HappyShareLibraryCreatePage from './HappyShareLibraryPageCreatePage';
import { ModulePermissionProps } from '../../../../../common/module/types';
import HappySharePerformancePage from './HappySharePerformancePage';
import { SALESKIT_BASE_PATH } from 'src/app/modules/sales-kit/constants';

const HappyShareLibraryRoutes: FC<RouteComponentProps & ModulePermissionProps> = ({
  enableRead,
  enableCreate,
  enableUpdate,
}) => {
  return (
    //PHKL Custom - s
    <Switch>
      <Redirect
        exact
        from={`${SALESKIT_BASE_PATH}${HAPPY_SHARE_MATERIAL_BASE_PATH}${HAPPY_SHARE_LIBRARY_BASE_PATH}`}
        to={`${SALESKIT_BASE_PATH}${HAPPY_SHARE_MATERIAL_BASE_PATH}${HAPPY_SHARE_LIBRARY_BASE_PATH}/list`}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${HAPPY_SHARE_MATERIAL_BASE_PATH}${HAPPY_SHARE_LIBRARY_BASE_PATH}/list`}
        render={(props) => (
          <HappyShareLibraryListPage
            {...props}
            enableRead={enableRead}
            enableCreate={enableCreate}
            enableUpdate={enableUpdate}
          />
        )}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${HAPPY_SHARE_MATERIAL_BASE_PATH}${HAPPY_SHARE_LIBRARY_BASE_PATH}/create`}
        component={HappyShareLibraryCreatePage}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${HAPPY_SHARE_MATERIAL_BASE_PATH}${RECRUIT_LIBRARY_BASE_PATH}/edit/:id`}
        component={HappyShareLibraryCreatePage}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${HAPPY_SHARE_MATERIAL_BASE_PATH}${RECRUIT_LIBRARY_BASE_PATH}/view/:id`}
        component={HappyShareLibraryCreatePage}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${HAPPY_SHARE_MATERIAL_BASE_PATH}${RECRUIT_LIBRARY_BASE_PATH}/performance/:id`}
        component={HappySharePerformancePage}
      />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
  //PHKL Custom - e
};

export default HappyShareLibraryRoutes;
